import { CARD_TYPES, FullCardType } from 'cards/constants/CardTypes';

export const CARD_TYPES_BY_URL_PARAM = {
  invitations: CARD_TYPES.invitation,
  'thank-you-cards': CARD_TYPES.thankyou,
  menus: CARD_TYPES.menu,
  programs: CARD_TYPES.program,
  enclosures: CARD_TYPES.details,
  'place-cards': CARD_TYPES.place,
  'save-the-date': CARD_TYPES.std,
  'digital-save-the-date': CARD_TYPES.std,
  'change-the-date': CARD_TYPES.ctd,
  'holiday-cards': CARD_TYPES.holiday,
  'bridal-shower': CARD_TYPES.weddingShower,
  'table-numbers': CARD_TYPES.tableNumber,
  'paper-add-ons': CARD_TYPES.paperAddOns,
} as const;

export type CardTypeUrl = keyof typeof CARD_TYPES_BY_URL_PARAM;

export const CARD_TYPE_TO_URL_MAP = new Map<FullCardType, CardTypeUrl>([
  [CARD_TYPES.bellyBand, 'paper-add-ons'],
  [CARD_TYPES.vellumJacket, 'paper-add-ons'],
  [CARD_TYPES.waxSeal, 'paper-add-ons'],
]);
